import { LoadingButton } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import React from 'react'

import CreateWorkspaceView from './CreateWorkspaceView'
import { ReactComponent as LeafIcon } from '../../../icons/icon_leaf.svg'

function NoInviteView() {
  return (
    <Box sx={{ paddingY: 5.25, paddingX: 6.25, textAlign: 'center' }}>
      <LeafIcon />

      <Typography variant="h1" color="primary.800" mt={2} mb={1}>
        Welcome to AirImpact
      </Typography>

      <Typography variant="body1" color="grey.500" mb={1.5}>
        AirImpact is currently open to a limited number of select users only.
      </Typography>

      <Typography variant="body1" color="grey.500" mb={4}>
        Let us know how AirImpact can help your project development journey and get access to the dashboard.
      </Typography>

      <LoadingButton
        onClick={() => window.open('https://airimpact.co/waitlist/', '_blank')}
        variant="contained"
        sx={{
          width: '320px',
          marginBottom: 2.5,
        }}
      >
        Request access
      </LoadingButton>
    </Box>
  )
}

export default function () {
  return <CreateWorkspaceView />
}
